import { OdataManager } from '@/api/odata/odata-manager';
import { Facility } from '@/api/model/interfaces';

export default class FacilityOdata extends OdataManager<Facility> {}
